export default __webpack_public_path__ + "static/media/megha.db168f44.png";